export default __webpack_public_path__ + "static/B0087-f2a5852dd9b937fc28078df01f30796d.png";